/* eslint-disable */
// TODO refactor for each, etc

import {config} from '@shared/_services/config';
import {authHeader, handleResponse} from '@shared/_helpers';
import {constants} from '@shared/_services/constants'

import UserApi from '@shared/_api/user';
import {
    ADD_USER_SUCCESS,
    DELETE_USER_SUCCESS,
    FETCH_ALL_USERS_SUCCESS,
    FETCH_USER_SUCCESS,
    UPDATE_USER_SUCCESS
} from "./mutationTypes";

const state = {
    usersLoaded: false,
    users: [],
    userFields: constants.usersFields,
    editUser: {
        firstName: null,
        lastName: null,
        email: '',
        roles: null,
        id: null,
        externalId: null,
        externalAccountType: null
    }
};

const getters = {
    usersArray: (state) => {
        let usersArray = [];
        if (state.users && state.users.length > 0) { // TODO check
            state.users.forEach(el => {
                let tmp = JSON.parse(JSON.stringify(el));
                tmp.roles = tmp.roles.map(role => role.name).join(', ');
                usersArray.push(tmp)
            })
        }
        return usersArray
    },
    userById: (state) => (id) => {
        if (state.users && state.users.length > 0) {
            let user = JSON.parse(JSON.stringify(state.users.find(el => {
                return el.id === id
            })));
            if (user && user.roles) {
                user.roles = user.roles.map(role => role.id);
                return user
            }
            return null
        }
        return null
    }
};

const actions = {
    fetchUserById({commit}, {id}) {
        return UserApi.fetchUser(id).then(user => commit(FETCH_USER_SUCCESS, user))
            .catch(error => {
                console.log(error)
            })
    },
    deleteUserById({commit}, {id}) {
        return UserApi.delete(id).then(() => commit(DELETE_USER_SUCCESS, id))
            .catch(error => {
                console.log(error)
            })
    },
    fetchUsers({commit}, {page, limit, filter}) {
        return UserApi.fetchAll(page, limit, filter).then(users => {
            commit(FETCH_ALL_USERS_SUCCESS, users);
            return users;
        }).catch(error => {
            console.log(error)
        })
    },
    addUserViaAdmin({commit, getters, state, rootState, dispatch}, {user}) {
        const roles = rootState.rolesManagement.roles;

        if (user.roles) {
            user.roles = user.roles.map(role => {
                return roles.find(el => el.id === role);
            })
        }
        return UserApi.add(user).then(user => {
            commit(ADD_USER_SUCCESS, user);
            return dispatch('fetchUsers');
        })
            .catch(error => {
                console.log(error)
            });
    },
    updateUserById({commit, dispatch, getters, state, rootState}, {user}) {
        const roles = rootState.rolesManagement.roles;
        if (user.roles) {
            user.roles = user.roles.map(role => {
                return roles.find(el => el.id === role.id)
            })
        }
        return UserApi.update(user).then(user => {
            commit(UPDATE_USER_SUCCESS, user);
            return dispatch('fetchUsers');
        })
            .catch(error => {
                console.log(error)
            });
    }
};

const mutations = {
    [FETCH_USER_SUCCESS](state, user) {
        state.editUser = user;
    },
    [DELETE_USER_SUCCESS](state, id) {
        const idx = state.users.findIndex(x => x.id === id);
        if (idx === -1) {
            // TODO
        } else {
            state.users.splice(idx, 1)
        }
    },
    [UPDATE_USER_SUCCESS](state, user) {
        // const idx = state.users.findIndex(x => x.id === user.id)
        // if (idx == -1) {
        //
        // } else {
        //     state.users.splice(idx, 1, user)
        // }
    },
    [ADD_USER_SUCCESS](state, user) {
        // TODO
    },
    [FETCH_ALL_USERS_SUCCESS](state, users) {
        state.users = users;
        state.usersLoaded = true;
    }
};

export const usersManagement = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};